module.exports = __webpack_public_path__ + "static/03-3aa97f40d3ed71dd2d1b42c36bd900f0.jpg";